import React, { useEffect, useState } from "react";
import axios from "axios";
import { dashboardURL } from "../../Config/Url";
import { useTranslation } from "react-i18next";
import Card from "react-bootstrap/Card";
import SpinnerLoading from "../Common/SpinnerLoading";
import WhiteLoader from "../Common/WhiteLoader";

import {formatUtcToDate} from "../../Helpers/DateHelper";
import { tr } from "date-fns/locale";
const DailyInvoiceSum = () => {
  const [dailyInvoiceSum, setDailyInvoiceSum] = useState();
  const { t: translator } = useTranslation();
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingNum, setIsLoadingNum] = useState(false);
 const currentDate = new Date();


  let config = {
    headers: {
      "X-IsMockup": false,
      "X-Tenantid": +localStorage.getItem("tenantId"),
    },
  };

  useEffect(() => {
    axios
      .get(`${dashboardURL}/daily-total-amount`, config)
      .then((result) => {
        setDailyInvoiceSum(result.data.amount);
        setIsLoading(false);
      })
      .catch((err) => console.log(err.response));
    
  }, []);

  return (
    <>
      {isLoading && (
        <div className="dashboard-card-spinner">
          <SpinnerLoading />
        </div>
      )}

      {!isLoading && (
        <>
          <Card.Body className="dashboard-card-body-pos">
            <div className="dashboard-card-body-pos-image">
              <span
                className="icon icon-tariffs-and-products_outline"
                style={{ fontSize: 40 }}
              ></span>
            </div>
            <div className="dashboard-card-body-pos-simpleData">
              {isLoadingNum ? <WhiteLoader /> : dailyInvoiceSum} €
            </div>
          </Card.Body>
          <Card.Footer className="dashboard-card-footer-pos">
            
            {translator("Dashboard-DailyInvoiceSum-Title")} <br/>
            
           {formatUtcToDate(currentDate.toString())}
          </Card.Footer>
        </>
      )}
    </>
  );
};

export default DailyInvoiceSum;
